import React from "react";

export const Santa = () => {
  return (
    <div className="santa">
      <div className="santa-body">
        <div className="santa-head">
          <div className="santa-ear" />
          <div className="santa-ear" />
          <div className="santa-hat" />
          <div className="santa-eye" />
          <div className="santa-eye" />
          <div className="santa-nose" />
          <div className="santa-mouth" />
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/components/Shared/Santa.js